export default __webpack_public_path__ + "static/media/login_logo.ff06eec9.png";